import { Container } from "react-bootstrap";
import useSearchQuery from "../Hooks/useSearchQuery";
import useContentsSugestions from "./useContentsSugestions";
import useDevelopersSugestions from "./useDevelopersSugestions";
import useExamplesSugestions from "./useExamplesSugestions";
import useGuidesSugestions from "./useGuidesSugestions";

const Search: React.FC = () => {
  const query = useSearchQuery();
  const sugestedContents = useContentsSugestions();
  const sugestedExamples = useExamplesSugestions();
  const sugestedDevelopers = useDevelopersSugestions();
  const sugestedGuides = useGuidesSugestions();

  return (
    <Container className='pt-3'>
      <h3>
        Esto tenemos sobre <i className='text-muted'>{query.get("query")}</i>
      </h3>
      <div className='list-group mb-3'>
        <div className='d-flex w-100 justify-content-between align-items-end list-group-item'>
          <h5 className='m-0'>Contenidos</h5>
          <p className='text-muted small m-0'>
            {sugestedContents.length} Resultado/s
          </p>
        </div>
        {sugestedContents.map(content => (
          <a
            href={`/content/${content.route}`}
            className='list-group-item list-group-item-action'>
            {content.title}
          </a>
        ))}
      </div>
      <div className='list-group mb-3'>
        <div className='d-flex w-100 justify-content-between align-items-end list-group-item'>
          <h5 className='m-0'>Desarrolladores</h5>
          <p className='text-muted small m-0'>
            {sugestedDevelopers.length} Resultado/s
          </p>
        </div>
        {sugestedDevelopers.map(developer => (
          <a
            href={`/developer/${developer.route}`}
            className='list-group-item list-group-item-action'>
            {developer.title}
          </a>
        ))}
      </div>
      <div className='list-group mb-3'>
        <div className='d-flex w-100 justify-content-between align-items-end list-group-item'>
          <h5 className='m-0'>Guías</h5>
          <p className='text-muted small m-0'>
            {sugestedGuides.length} Resultado/s
          </p>
        </div>
        {sugestedGuides.map(guide => (
          <a
            href={`/guide/${guide.route}`}
            className='list-group-item list-group-item-action'>
            {guide.title}
          </a>
        ))}
      </div>
      <div className='list-group mb-3'>
        <div className='d-flex w-100 justify-content-between align-items-end list-group-item'>
          <h5 className='m-0'>Ejemplos</h5>
          <p className='text-muted small m-0'>
            {sugestedExamples.length} Resultado/s
          </p>
        </div>
        {sugestedExamples.map(example => (
          <a
            href={`/example/${example.route}`}
            className='list-group-item list-group-item-action'>
            {example.title}
          </a>
        ))}
      </div>
    </Container>
  );
};

export default Search;
